<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <table-with-checkbox :title="title"
                               :sub-title="subtitle"
                               :data="tableData" 
                               :columns-titles="tableColumnsTitles"
                               :columns-values="tableColumnsValues"
                               @rowSelectedChange="onSelectChange">
          </table-with-checkbox>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import TableWithCheckbox from '../Utils/TableWithCheckbox.vue'

  export default {

    components: {
      TableWithCheckbox
    },
    // data () {
    //   // return {
    //   //   plop: null,
    //   // }
    // },
    props: {
      tableData: null,
      tableColumnsTitles: null,
      tableColumnsValues: null,
      title: null,
      subtitle: null,
    },

    methods: {
      // event handler for when a row is selected in the table
      onSelectChange (row) {
        this.$emit('rowSelectedChange', row)
      }
    }
  }

</script>
<style>

</style>




// WEBPACK FOOTER //
// ItemList.vue?fc556fe4